import axios from 'axios'
import i18n from '@/i18n'
import store from '@/store'
import { MessageBox, Message } from 'element-ui'

const requestAxios = axios.create({
  baseURL: `${process.env.API_DOMAIN}${process.env.API_VERSION}`,
  headers: {
    'Accept': 'application/json;charset=utf-8',
    'Content-Type': 'application/json;charset=utf-8'
  },
  timeout: 15000
})

requestAxios.interceptors.request.use(config => {
  let token = store.getters['auth/token']
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
  }

  return config
},
error => {
  return Promise.reject(error)
})

requestAxios.interceptors.response.use(response => {
  return response
}, error => {
  const response = error.response
  switch (response.status) {
    case 401:
      MessageBox.confirm(i18n.t('messages.you_have_been_logged_out'), i18n.t('messages.logout_confirmation'), {
        confirmButtonText: i18n.t('messages.re_login'),
        showClose: false,
        showCancelButton: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            instance.confirmButtonText = i18n.t('messages.loading')
            setTimeout(() => {
              done()
              setTimeout(() => {
                instance.confirmButtonLoading = false
              }, 300)
            }, 1500)
          } else {
            done()
          }
        }
      }).then(() => {
        store.dispatch('auth/resetTokenAction').then(() => {
          location.reload()
        })
      })
      break
    case 400:
      if (response.data.message !== null) {
        if (response.data.message === 'messages.auth.invalid_token') {
          store.dispatch('auth/resetTokenAction').then(() => {
            location.reload()
          })
        } else {
          Message.error(response.data.message)
        }
      } else {
        Message.error(this.$t('messages.unexpected'))
      }
      break
    case 500:
      if (response.data.message !== null) {
        Message.error(response.data.message)
      } else {
        Message.error(this.$t('messages.unexpected'))
      }
      break
    default:
      return Promise.reject(error)
  }
  return Promise.reject(error)
})

export default requestAxios



// WEBPACK FOOTER //
// ./src/utils/request.js